var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main home"},[_c('div',{staticStyle:{"overflow":"scroll","height":"100vh"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.homeContent.content)}})]),_c('div',{staticClass:"dzHome_btn"},[_c('van-button',{attrs:{"type":"info","block":"","size":"large"},on:{"click":_vm.toPush}},[_vm._v("\n      去报名\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }